import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import DataTableBureauOrderAgentScolarite from "./DataTableAgentDemande";
import DataTableBureauOrderEnseignant from "./DataTableAgentDemandeEnseignant";

const AgentDemande = props => {
  const [section, setSection] = useState(1)
  const renderBlock = section => {
    if (section === 1) {
      return <DataTableBureauOrderAgentScolarite />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Demande Administrative")} | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Validation demande personnel administratif")}
                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(AgentDemande))
AgentDemande.propTypes = {
  t: PropTypes.any,
}
